import { requestHandler } from 'lib/api';
import { Dispatch } from 'redux';

export const getAllSGRWarrantyRequests = async (
  dispatch: Dispatch,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessSGRWarrantyRequests = async (
  dispatch: Dispatch,
  businessIdentifier: string,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest/${businessIdentifier}?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSGRWarrantyRequestMissingApprovals = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/missing-approvals`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSGRWarrantyRequestFile = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/file`,
    dispatch,
    responseType: 'arraybuffer',
  });
  if (response) {
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return {
      blob: blob,
      contentType: 'application/pdf',
    };
  }
};

export const getPublicSGRWarrantyRequestFile = async (
  dispatch: Dispatch,
  secretId: string,
  warrantyRequestId: number,
  clientIdentifier: string,
  principalIdentifier: string,
  warrantyType: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `public/express/${secretId}/sgrWarrantyRequestFile/${warrantyRequestId}/${clientIdentifier}/${principalIdentifier}/${warrantyType}`,
    dispatch,
    responseType: 'arraybuffer',
  });
  if (response) {
    const blob = new Blob([response.data], { type: 'application/pdf' });
    return {
      blob: blob,
      contentType: 'application/pdf',
    };
  }
};

export const getPrincipalInfo = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest/principal/${warrantyRequestId}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSGRWarrantyRequestPayments = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/payments`,
    dispatch,
  });
  if (response) return response.data;
};

export const createSGRWarrantyRequest = async (
  dispatch: Dispatch,
  data: unknown,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/sgrWarrantyRequest`,
    dispatch,
    data,
  });

  if (response) return response.data;
};

export const createSGRWarrantyRequestPruffConnect = async (
  dispatch: Dispatch,
  secretId: string,
  data: unknown,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/express/${secretId}/sgrWarrantyRequest`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const updateSGRWarrantyRequest = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
  data: unknown,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}`,
    dispatch,
    data,
  });

  if (response) return response.data;
};

export const updateSGRWarrantyRequestComitee = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
  data: unknown,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/comitee`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const approveSGRWarrantyRequest = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
  data: unknown,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/approve`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const rejectSGRWarrantyRequest = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
  data: unknown,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/reject`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const startClaimProcess = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
  data: { claimReason: string },
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/claim`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const deleteSGRWarrantyRequest = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}`,
    dispatch,
  });

  if (response) return response.data;
};

export const deleteSGRWarrantyRequestApproval = async (
  dispatch: Dispatch,
  warrantyRequestId: number,
  approvalId: number,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/approval/${approvalId}`,
    dispatch,
  });
  if (response) return response.data;
};
